module.exports = __webpack_public_path__ + "img/3.524b0836.png";